export default __webpack_public_path__ + "static/media/BrainBreak cards101.8e25a748.png";